import Swal from "sweetalert2";

const SweetConfirmationLogout = () => {
  return Swal.fire({
    title: "Logout",
    text: "Are you sure you want to Logout?",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel",
    reverseButtons: true, // Makes Cancel appear on the left
  }).then((result) => {
    return {
      dismiss: result.dismiss,
      isConfirmed: result.isConfirmed,
      isDenied: result.isDenied,
      isDismissed: result.isDismissed,
    };
  });
};

export default SweetConfirmationLogout;
